module.exports = __webpack_public_path__ + "img/ProductLaunchOverlay.34426dd5.jpg";